import { BrandIconSVG } from 'atto-svgs';

import { styled } from '../../stitches.config';

export const BrandIconIcons = {
  'app-store': BrandIconSVG.AppStore,
  'google-play': BrandIconSVG.GooglePlay,
  'mac-app-store': BrandIconSVG.MacAppStore,
  wireguard: BrandIconSVG.Wireguard,
};

export type BrandIconName = keyof typeof BrandIconIcons;
export const BrandIconNames = Object.keys(BrandIconIcons) as BrandIconName[];

export interface BrandIconProps {
  icon: BrandIconName;
}

const BrandIconLiteral = styled('svg', {
  display: 'flex',
  width: 'auto',
});
BrandIconLiteral.displayName = 'BrandIconLiteral';

export function BrandIcon({ icon, ...remaining }: BrandIconProps) {
  const NamedIcon = BrandIconIcons[icon];

  if (!NamedIcon) {
    return null;
  }

  // TODO: react-three-fiber globally augments JSX.IntrinsicElements with ~150
  // three.js elements, which inflates the Stitches polymorphic `as` union past
  // TS's representable limit (TS2590) in any consumer that also pulls in r3f
  // (e.g. @meterup/spatial). atto's own type-check has no r3f, so there's no
  // error here — hence @ts-ignore rather than @ts-expect-error (the latter is
  // reported as unused when atto type-checks standalone). Remove once atto
  // ships built declarations or Stitches' `as` typing is narrowed.
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore -- TS2590, see TODO above
  return <BrandIconLiteral as={NamedIcon} {...remaining} />;
}
